import api from './api'
import apiFactory from './api-factory'

const entryTagGroup = {
  ...apiFactory('/api/polls/entry_tag_group/', ['getList'], { dehydrate }),

  getTagGroup(pk) {
    return api
      .get(`/api/polls/entry_tag_group/${pk}/`)
      .then((response) => dehydrate(response.data))
  },
}

export function dehydrate({ pk, name }) {
  return {
    pk,
    name,
  }
}
export default entryTagGroup
